import { useGetIdentity, useGetList } from "ra-core";
import { IS_DEMO } from "../env";

/** True while the signed-in rep has an open dial session (spec 10 §4 live dot and "Appel en cours" pill). */
export const useActiveDialSession = (): boolean => {
  const { identity } = useGetIdentity();
  const { total } = useGetList(
    "dial_sessions",
    {
      filter: { sales_id: identity?.id, "ended_at@is": null },
      pagination: { page: 1, perPage: 1 },
    },
    {
      enabled: identity?.id != null && !IS_DEMO,
      retry: false,
      refetchInterval: 30_000,
    },
  );
  return (total ?? 0) > 0;
};
